import { ActionTypes, GlobalModals } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';


const ConfirmationModalActions = {

    open (onConfirm, message, { ...confirmationProps }, closeText, confirmButtonText, title = null, messageValues, onCancel) {
        AppDispatcher.dispatch({
            type: GlobalModals.CONFIRM,
            data: Object.assign({
                onConfirm,
                onCancel,
                message,
                messageValues,
                closeText,
                confirmButtonText,
                title
            }, confirmationProps),
            actionType: ActionTypes.MODAL_OPENED
        });
    }
};

export default ConfirmationModalActions;



// WEBPACK FOOTER //
// ./src/actions/ConfirmationModalActions.js